export default {
    common: {
        email: 'بريد إلكتروني',
        LoginBtn: 'تسجيل الدخول',
        SignUpBtn: 'التسجيل',
        SubmitBtn: 'ُقدِّم',
        ExitBtn: 'تصدير',
        LogoutBtn: 'تسجيل الخروج'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'يرجى التحقق من بريدك الإلكتروني للحصول على رمز التحقق.',
        VerificationCode: 'رمز التحقق'
    },
    header: {
        OrderHistory: 'تاريخ الطلب',
        MYACCOUNT: 'حسابي',
        WelcomeBack: 'مرحبا بعودتك'
    },
    detail: {
        TotalOrders: 'إجمالي الطلبات',
        TotalProducts: 'إجمالي المنتجات',
        WonderlandPoints: 'نقاط بلاد العجائب',
        APMCredits: 'اعتمادات APM',
        ExpireOn: 'تاريخ الاستحقاق',
        NoAPMCredits: 'ا توجد اعتمادات APM',
        CreditsLoading: 'Credits loading'
    },
    panel: {},
    entry: {
        Client: 'العملاء',
        OrderDate: 'تاريخ الطلب',
        DeliverDate: 'تاريخ التسليم',
        Description: 'إيضاحات',
        Total: 'المجموع'
    },
    board: {
        Order: 'أمر',
        Date: 'تواريخ',
        Total: 'المجموع'
    },
    order: {
        OrderID: 'معرف الطلب',
        PurchasePlace: 'موقع',
        PurchaseDate: 'تاريخ الشراء',
        TotalPrice: 'السعر الإجمالي',
    },
    product: {
        Name: 'اسم',
        SKU: 'رمز التخزين التعريفي',
        Size: 'مقاس',
        Quantity: 'كمية',
        Price: 'سعر',
        WarrantyUntil: 'الضمان حتى',
    }
}


// WEBPACK FOOTER //
// ./src/locales/ar/index.js